import { financeManagerFeatures } from '../../apps/financeManager/featureFlags/financeManagerFeatures';
import Constants from '../Constants';
import { LabelConstant } from '../LabelConstant';

const { isFA722WarehousingAppLabel } = financeManagerFeatures;
export const LotConstants = {
    closedLots: 'Closed Lots',
    openLots: 'Open Lots',
    createNewLot: 'Create New Lot',
    lotNotFound: 'No Lots Found',
    filterBy: 'Filter By:',
    equityPerHead: 'Equity Per Head',
    list: {
        limit: 20,
        offset: 0,
        initialState: {
            filter: { lotId: 1, limit: 20, offset: 0 },
        },
        table: {
            navigation: Constants.Routes.UPDATE_RECEIVE_CATTLE_FORM,
            routeParameter: 'tableId',
            headers: {
                date: {
                    label: 'Date',
                    apiResName: 'date',
                    type: 'date',
                },
                tableId: {
                    label: 'Table ID',
                    apiResName: 'tableId',
                    type: 'prefix',
                    rPrefix: 'R',
                    sPrefix: 'S',
                },
                tableName: {
                    label: 'Table Name',
                    apiResName: 'tableName',
                },
                location: {
                    label: 'Location',
                    apiResName: 'location',
                },

                headCount: {
                    label: 'Head Count',
                    apiResName: 'hdCount',
                },
                payWeight: {
                    label: 'Pay Weight',
                    apiResName: 'payWeight',
                },
                complete: {
                    label: 'Complete',
                    apiResName: 'status',
                    type: 'checkbox',
                },
            },
        },
    },
    owner: 'Owner',
    reportTableHeadings: {
        quickBooksAccountNumber: 'QuickBooks Acct #',
        lotName: 'Lot Name',
        ownerName: 'Owner Name',
        currentCCCBalance: 'Current CCC Balance',
        currentWarehouseBalance: isFA722WarehousingAppLabel
            ? 'Current Warehouse Line Balance'
            : 'Current CCC Balance',
        totalInterestCharged: 'Total Interest Charged',
        total: 'Total:',
    },
    LotSummaryConstants: {
        dateReceived: 'Date Received',
        feedLot: 'Feedlot',
        lot: 'Lot',
        sex: 'Sex',
        receivingWeightPerHeadCount: 'Receiving Weight/HD',
        currentHeadCount: 'Current Head Count',
        daysOnFeed: 'Days On Feed',
        currentWeightPerHeadCount: 'Current Weight/HD',
        currentPricePerLb: 'Current Price/LB',
        currentValuePerHd: 'Current Value/Hd',
        currentLotValue: 'Current Lot Value',
        costPerHead: 'In Cost Per Head',
        currentInventory: 'Current Inventory',
        prePaidFeed: 'Pre-paid Feed',
    },
    owners: [
        {
            name: LabelConstant.Owner.CREATE_OWNER,
            id: LabelConstant.Owner.CREATE_OWNER,
        },
    ],
    feedlots: [
        {
            name: LabelConstant.FeedLots.CREATE_FEEDLOT,
            id: LabelConstant.FeedLots.CREATE_FEEDLOT,
        },
    ],
    modal: {
        form: {
            feedlotName: 'Feedlot Name',
            ownerName: 'Owner Name',
            email: 'Email',
            contact: 'Contact',
            phoneNumber: 'Phone Number',
            taxId: 'Tax Id',
            streetAddress: 'Street Address',
            city: 'City',
            state: 'State',
            zip: 'Zip',
            pleaseProvideAnOwnerName: ' Please provide an owner name',
            looksGood: 'Looks good!',
            validEmail: 'Please provide a Valid Email.',
            phone: 'Phone',
            contactFeedLot: 'Contact Name',
            validContact: ' Please provide a contact name.',
            name: 'Name',
            validName: ' Please provide a feedlot name.',
        },
    },
    placeHolders: {
        search: 'Search',
    },
    button: {
        clearFilter: 'Clear Filter',
        close: 'Close',
        open: 'Open',
    },
    LotTable: {
        lot: 'Lot #',
        company: 'Company',
        feedLot: 'Feedlot',
        closeDate: 'Close Date',
        headCount: 'Head Count',
        total: 'Total',
        lineBalance: 'Line Balance',
        cccBalance: isFA722WarehousingAppLabel
            ? 'Warehouse Line Balance'
            : 'CCC Balance',
        nofeedlot: ' No feedlot',
    },
    up: 'up',
    down: 'down',

    ContactTab: {
        addressAndContactInformation: 'Address & Contact Information',
        taxId: 'Tax ID:',
    },

    reports: {
        TABLE_HEADERS: [
            { key: 'lot', label: 'Lot' },
            { key: 'dateIn', label: 'Date In' },
            { key: 'breedSex', label: 'Breed/Sex' },
            { key: 'currentHC', label: 'Current HC' },
            { key: 'headDays', label: 'Head Days' },
            { key: 'estTotalWeight', label: 'Est Total Weight' },
            { key: 'lotValue', label: 'Lot Value' },
            { key: 'equityPerHead', label: 'Equity Per Head' },
            { key: 'noteBalance', label: 'Note Balance' },
            { key: 'noteFace', label: 'Note Face' },
        ],
        FEED_BILL_OWNER_DATA_TABLE_HEADERS: [
            { key: 'lotName', label: 'Lot Name' },
            { key: 'headDaysOnFirstDate', label: 'Head Days on Start Date' },
            { key: 'headDaysOnSecondDate', label: 'Head Days on End Date' },
            {
                key: 'headDaysDifference',
                label: 'Difference Between Head Days',
            },
            { key: 'headCountOnFirstDate', label: 'Head Count on Start Date' },
            { key: 'headCountOnSecondDate', label: 'Head Count on End Date' },
            {
                key: 'headCountDifference',
                label: 'Difference Between Head Count',
            },
        ],
    },
};
